//When analytics is ready
ShopifyAnalytics.lib.ready(function(){
  
  //set up link tracking
  function trackingLink($this, type){
    var href = $this.html();
    return "ga('send', 'event', 'Contact Links', '"+type+"','"+href+"')";
  }


  $('[href*=tel]').attr("onclick", function(){
    return trackingLink($(this), "user-phoned");
  }).addClass('number');

  $('[href*=mailto]').attr("onclick", function(){
    return trackingLink($(this), "user-emailed");
  }).addClass('email');

  $('[href*=fax]').attr("onclick", function(){
    return trackingLink($(this), "user-faxed");
  }).addClass('fax');
  

  //Check forms for success
  if($('#contact-success').length > 0) {
    ga('send', 'event', 'Contact Form', 'submit','');
  }
  if($('#contact_form-1544072917883').find('.alert-success').length > 0) {
    ga('send', 'event', 'Newsletter', 'submit','');
  }

});
	